<template>
    <div>
        <div class="search-box">
            <p>是否留学生：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.isInternational" >
                <a-select-option  value=true>是</a-select-option>
                <a-select-option  value=false>否</a-select-option>
            </a-select>
            <p>层次：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.level" >
                <a-select-option  value='博士研究生'>博士研究生</a-select-option>
                <a-select-option  value='硕士研究生'>硕士研究生</a-select-option>
            </a-select>
            <p>学位类别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.degreeCategory" >
                <a-select-option  value='学术型'>学术型</a-select-option>
                <a-select-option  value='专业型'>专业型</a-select-option>
            </a-select>
            <p>学习形式：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.learningForm" >
                <a-select-option  value='全日制'>全日制</a-select-option>
                <a-select-option  value='非全日制'>非全日制</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>

        </div>
        <div class="operation-box">
                <a-button type="primary" class="btn" icon="file-search" @click="wholeMentoring('look')" >查看详情</a-button>
            </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,info } from '@/baseAPI/master/student'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        data () {
            return {
                xbArr:[],
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                },
                permissions:[],
                year:'',
                yearShowOne:false,
                courseId:'',
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                sysRoles:[],
                columns:[
                        {
                            title: '序号',
                            align:'center',
                            width:'5%',
                            customRender: (text, row, index) => {
                                return { children: index+1+''};
                            },
                        },
                        {
                            title: '学号',
                            dataIndex: 'studentNo',
                            align:'center',
                        },
                        {
                            title: '姓名',
                            dataIndex: 'studentName',
                            align:'center',
                        },
                        {
                            title: '性别',
                            dataIndex: 'genderCode',
                            align:'center',
                            width:'5%',
                        },
                        {
                            title: '是否留学生',
                            dataIndex: 'isInternational',
                            align:'center',
                            width:'5%',
                            customRender: (text, row, index) => {
                                return text ?'是':'否'
                            },
                        },
                        // {
                        //     title: '出生日期',
                        //     dataIndex: 'birthday',
                        //     align:'center'
                        // },
                        {
                            title: '年级',
                            dataIndex: 'grade',
                            align:'center'
                        },
                        {
                            title: '层次',
                            dataIndex: 'level',
                            align:'center'
                        },
                        {
                            title: '学位类型',
                            dataIndex: 'degreeCategory',
                            align:'center'
                        },
                        {
                            title: '学习形式',
                            dataIndex: 'learningForm',
                            align:'center',
                        },
                        {
                            title: '学制',
                            dataIndex: 'schoolLength',
                            align:'center',
                            width:'5%',
                        },
                        {
                            title: '院系',
                            dataIndex: 'orgName',
                            align:'center',
                        },
                        {
                            title: '专业',
                            dataIndex: 'courseName',
                            align:'center',
                        },
                        {
                            title: '导师编号',
                            dataIndex: 'teacherId',
                            align:'center',
                        },
                        {
                            title: '导师姓名',
                            dataIndex: 'teacherName',
                            align:'center',
                        },
                        // {
                        //     title: '学籍状态',
                        //     dataIndex: 'studentStatus',
                        //     align:'center',
                        // }
                    ]
            }
        },
        mounted () {
            this.$store.state.user.sysRoles.forEach(element => {
                this.sysRoles.push(element.code)
            });
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            // this.searchFrom.semester=this.year+this.season[new Date().getMonth()+1]
            this.fetch()
        },
        methods:{
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
            wholeMentoring(type){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/master/student/info?id='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择一条记录',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
